module.exports = __webpack_public_path__ + "img/0Q3A3001_L_BlackMatted_MockedUp.e95a13ce.jpg";